import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetChilds = async (setLoading, institutionId) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();

    const result = await axios.get(`${apiConfig.baseURL}/childs`, {
      headers: apiConfig.headers,
      params: {
        institutionId: institutionId,
      },
    });

    return result;
  } catch (error) {
    console.error("Error fetching childs:", error);
    return error;
  }
};
